import { createAction } from "redux-actions";
import { HttpError } from "fetch-run/src/use/error";
//
import { createPromiseActionTypes } from "../../utils/redux";
import Api from "../../services/Api";
import getTime from "date-fns/get_time";
import { goToScreen } from "../modal";
import { ajaxPendingAction, ajaxSuccessAction, ajaxErrorAction } from "../ajax";
import { setLocationFeeAction } from "../locations";
import { getVideosAction } from "../videos";

//
// TYPES
//
export const MODEL_SHOW = "models/MODEL_SHOW";
export const MODEL_SET = "models/MODEL_SET";
export const MODELS_GET = createPromiseActionTypes("models/MODELS_GET");
export const MODELS_OFFLINE_GET = createPromiseActionTypes(
  "models/MODELS_OFFLINE_GET"
);
export const MODEL_GET = createPromiseActionTypes("models/MODEL_GET");
export const MODEL_FAVORITE = "models/MODEL_FAVORITE";
export const MODEL_UNFAVORITE = "models/MODEL_UNFAVORITE";
export const MODELS_FAVORITE_GET = createPromiseActionTypes(
  "models/MODELS_FAVORITE_GET"
);
export const MODELS_VISIBLE_SET = "MODELS_VISIBLE_SET";
export const MODEL_PREBOOK = createPromiseActionTypes("models/MODEL_PREBOOK");
export const MODELS_COUNT = createPromiseActionTypes("models/MODELS_COUNT");
export const ACCEPT_TIME = "models/ACCEPT_TIME";
export const REJECT_TIME = "models/REJECT_TIME";
export const AREA_SET = "models/AREA_SET";

//
// ACTIONS
//
export const _setAreaAction = createAction(AREA_SET);

export function setAreaAction(areaId) {
  return (dispatch) => {
    dispatch(_setAreaAction(areaId));
    dispatch(getModelsAction());
  };
}

export const setModelAction = createAction(MODEL_SET);
const _showModelAction = createAction(MODEL_SHOW);

export const showModelAction = (modelId) => async (dispatch, getState) => {
  const { models, auth } = getState();

  const model = models.entities[modelId];
  const isIncomplete = !model.reviews;

  if (isIncomplete) {
    dispatch(getModelPendingAction());

    try {
      let payload;

      if (auth.isPremium) {
        payload = await Api.getModelPremium(model.id, model.online);
      } else {
        payload = await Api.getModel(model.id, model.online);
      }

      dispatch(getModelFulfilledAction(payload));
    } catch (err) {
      dispatch(getModelRejectedAction(err));
    }
  }

  dispatch(_showModelAction(model.id));
};

// Model online Alert
export const createModelAlertAction = (modelId, duration) => async (
  dispatch
) => {
  dispatch(ajaxPendingAction());

  try {
    const payload = await Api.createModelAlert(modelId, duration);

    dispatch(ajaxSuccessAction(payload));
  } catch (err) {
    if (err.data) {
      dispatch(ajaxErrorAction(err.data));
    } else {
      throw err;
    }
  }
};

const _setModelsVisibleAction = createAction(MODELS_VISIBLE_SET);

export const setModelsVisibleAction = (visible) => async (
  dispatch,
  getState
) => {
  const { auth, models } = getState();

  dispatch(_setModelsVisibleAction(visible));

  if (auth.isPremium && visible === "favorite" && !models.favoriteLoaded) {
    dispatch(getModelsFavoriteAction());
  }

  if (visible === "videos") {
    dispatch(getVideosAction());
  }
};

// Get Models
const getModelsOnlinePendingAction = createAction(MODELS_GET.PENDING);
const getModelsOnlineFulfilledAction = createAction(MODELS_GET.FULFILLED);
const getModelsOnlineRejectedAction = createAction(MODELS_GET.REJECTED);

export const getModelsIfNeededAction = () => async (dispatch, getState) => {
  const { models } = getState();

  if (models.online.length > 1) {
    dispatch(goToScreen("models"));
  } else {
    dispatch(getModelsAction());
  }
};

const getModelsOnlineAction = () => async (dispatch, getState) => {
  const { booking, intl, models, filters } = getState();

  dispatch(getModelsOnlinePendingAction());

  try {
    const payload = await Api.getModelsOnline(
      intl.cityId,
      getTime(booking.date),
      booking.duration,
      booking.outcall,
      booking.genderId,
      filters.values,
      models.areaId
    );
    dispatch(getModelsOnlineFulfilledAction(payload));
  } catch (err) {
    if (err instanceof HttpError) {
      dispatch(getModelsOnlineRejectedAction(err));
    } else {
      throw err;
    }
  }
};

export const getModelsAction = () => async (dispatch) => {
  dispatch(getModelsOnlineAction());
  dispatch(getModelsOfflineAction());
};

// Count Models
const countModelsPendingAction = createAction(MODELS_COUNT.PENDING);
const countModelsFulfilledAction = createAction(MODELS_COUNT.FULFILLED);
const countModelsRejectedAction = createAction(MODELS_COUNT.REJECTED);

export const countModelsAction = () => async (dispatch, getState) => {
  const { booking, intl, filters, models } = getState();

  dispatch(countModelsPendingAction());

  try {
    const payload = await Api.countModels(
      intl.cityId,
      getTime(booking.date),
      booking.duration,
      booking.outcall,
      booking.genderId,
      filters.values,
      models.areaId
    );
    dispatch(countModelsFulfilledAction(payload));
  } catch (err) {
    dispatch(countModelsRejectedAction(err));
  }
};

// Get Models (offline)
const getModelsOfflinePendingAction = createAction(MODELS_OFFLINE_GET.PENDING);
const getModelsOfflineFulfilledAction = createAction(
  MODELS_OFFLINE_GET.FULFILLED
);
const getModelsOfflineRejectedAction = createAction(
  MODELS_OFFLINE_GET.REJECTED
);

export const getModelsOfflineAction = () => async (dispatch, getState) => {
  const { booking, intl, models, filters } = getState();

  dispatch(getModelsOfflinePendingAction());

  try {
    const payload = await Api.getModelsOffline(
      intl.cityId,
      getTime(booking.date),
      booking.duration,
      booking.outcall,
      booking.genderId,
      filters.values,
      models.areaId
    );
    dispatch(getModelsOfflineFulfilledAction(payload));
  } catch (err) {
    dispatch(getModelsOfflineRejectedAction(err));
  }
};

// Get Models (favorite)
const getModelsFavoritePendingAction = createAction(
  MODELS_FAVORITE_GET.PENDING
);
const getModelsFavoriteFulfilledAction = createAction(
  MODELS_FAVORITE_GET.FULFILLED
);
const getModelsFavoriteRejectedAction = createAction(
  MODELS_FAVORITE_GET.REJECTED
);

export const getModelsFavoriteAction = () => async (dispatch, getState) => {
  dispatch(getModelsFavoritePendingAction());

  try {
    const payload = await Api.getModelsFavorite();
    dispatch(getModelsFavoriteFulfilledAction(payload));
  } catch (err) {
    dispatch(getModelsFavoriteRejectedAction(err));
  }
};

// Get Model
const getModelPendingAction = createAction(MODEL_GET.PENDING);
const getModelFulfilledAction = createAction(MODEL_GET.FULFILLED);
const getModelRejectedAction = createAction(MODEL_GET.REJECTED);

// Book Model
const preBookModelPendingAction = createAction(MODEL_PREBOOK.PENDING);
const preBookModelFulfilledAction = createAction(MODEL_PREBOOK.FULFILLED);

export const bookModelAction = (modelId) => async (dispatch, getState) => {
  const state = getState();
  const { locations, booking, intl } = state;

  dispatch(preBookModelPendingAction(modelId));

  // 1- calculate travel fee if needed
  if (locations.active) {
    try {
      const fee = await Api.getLocationFee(locations.active, modelId);
      dispatch(setLocationFeeAction(fee));
    } catch (err) {
      if (err.data) {
        dispatch(ajaxErrorAction(err.data));
      } else {
        throw err;
      }
    }
  }

  // 2- Pre-book Model (verify still available)
  try {
    await Api.preBookModel(
      modelId,
      intl.cityId,
      getTime(booking.date),
      booking.duration
    );
    dispatch(preBookModelFulfilledAction(modelId));
  } catch (err) {
    if (err.data) {
      dispatch(ajaxErrorAction(err.data));
    } else {
      throw err;
    }
  }
};

// Favorite Model
const _favoriteModelAction = createAction(MODEL_FAVORITE);
const _unfavoriteModelAction = createAction(MODEL_UNFAVORITE);

export const favoriteModelAction = (modelId) => async (dispatch) => {
  // Extra-optimistic update
  // Server may fail because of Authentication, but we ignore every server error
  dispatch(_favoriteModelAction(modelId));

  try {
    await Api.favoriteModel(modelId);
  } catch (err) {
    // Silently ignore errors
  }
};

export const unfavoriteModelAction = (modelId) => async (dispatch) => {
  // Extra-optimistic update
  // Server may fail because of Authentication, but we ignore every server error
  dispatch(_unfavoriteModelAction(modelId));

  try {
    await Api.unfavoriteModel(modelId);
  } catch (err) {
    // Silently ignore errors
  }
};

export const acceptTimeAction = createAction(ACCEPT_TIME);
export const rejectTimeAction = createAction(REJECT_TIME);
